import _ from 'lodash';
import React, { Component } from "react";
import { Button, ButtonToolbar, Checkbox, DropdownButton, MenuItem, Modal } from 'react-bootstrap';
import Alert from 'react-s-alert';
import AuthContext from '../auth-context';
import LoadingIndicator from '../Components/LoadingIndicator/LoadingIndicator';
import CSVWrapper from '../Shared/CSVWrapper';
import DealsService from '../utils/DealsService';
import SeminarRegistrationsService from '../utils/SeminarRegistrationsService';
import RegistrationsTable from "./RegistrationsTable";

class RegistrationsListView extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      filter: {},
      items: [],
      textFilter: '',
      flags: [],
      selectedItems: [],
      showMessageModal: false,
      modalMessageAudience: 'primary',
      emailGroupMessages: props.emailGroupMessages,
      smsGroupMessages: props.smsGroupMessages,
      leadmachineConfig: props.leadmachineConfig,
      markDeadDealCreateFollowUp: true,
      markDeadDealReason: 'non_attendee',
      markDeadDealPriority: '4',
      markDeadDealLeadType: 'seminar_register_did_not_attend'
    };
    this.debouncedFetchItems = _.debounce(() => this.fetchItems(), 300)
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true, view: this.props.view, currentPage: 1 }, this.debouncedFetchItems)
  }

  leadMachineGroupTasks = () => {
    if (!this.state.leadmachineConfig) return []
    const task_types = Object.keys(this.state.leadmachineConfig.tasks.types)
    return task_types.map((task_type) => {
      let task = this.state.leadmachineConfig.tasks.types[task_type]
      task.task_type = task_type
      return task
    }).filter((task) => task.group_task)
  }

  onPageChange(currentPage) {
    this.setState({ currentPage }, this.debouncedFetchItems);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view) {
      this.setState({ view: this.props.view, emailGroupMessages: this.props.emailGroupMessages, smsGroupMessages: this.props.smsGroupMessages, leadmachineConfig: this.props.leadmachineConfig, currentPage: 1 }, this.debouncedFetchItems)
    }
  }

  fetchItems() {
    if (!this.state.view) return
    this.setState({ loadingInProgress: true })
    SeminarRegistrationsService.index({ seminar_id: this.props.match.params.id, text_filter: this.state.textFilter, view: this.state.view, page: this.state.currentPage, per: this.state.per }).then(response => {
      this.setState({ loadingInProgress: false, items: response.results })
    })
  }

  handleFlagChange = (flags) => {
    this.setState({ flags: flags })
  }

  itemSelectAllChanged = (selected) => {
    var items = JSON.parse(JSON.stringify(this.state.items)).map((item) => {
      item.isSelected = selected
      return item
    })
    this.setState({ items: items })
  }

  itemSelectStateChanged = (id, selected) => {
    var items = JSON.parse(JSON.stringify(this.state.items)).map((item) => {
      if (item.id === id) item.isSelected = selected
      return item
    })

    this.setState({ items: items })
  }

  selectedItems = () => {
    return this.state.items.filter((item) => item.isSelected)
  }

  groupActionsEnabled = () => {
    return this.selectedItems().length > 0
  }

  closeMessageModal = () => {
    this.setState({ showMessageModal: false, modalMessageType: null, modalMessageIndex: null, modalMessageItem: null });
  }

  showMessageModal = (type, index, item) => {
    this.setState({ showMessageModal: true, modalMessageType: type, modalMessageIndex: index, modalMessageItem: item });
  }

  sendMessage = (testMode) => {
    this.setState({ sendingMessage: true })
    const params = { deal_ids: this.selectedItems().map((item) => item.id), message_type: this.state.modalMessageType, message_item: this.state.modalMessageItem, test_mode: testMode, audience: this.state.modalMessageAudience }
    DealsService.sendGroupMessage(params)
      .then((response) => {
        if (!testMode) this.closeMessageModal()
        this.setState({ sendingMessage: false })
        Alert.success('Sent message OK')
      })
      .catch((response) => {
        Alert.error(`<h1>Error sending message</h1><p>${response.data.message}</p>`, { html: true, timeout: 10000 })
        this.setState({ sendingMessage: false })
      })
  }

  showLMTaskModal = (index, item) => {
    this.setState({ showGroupActionLMTaskModal: true, modalLMTaskIndex: index, modalLMTaskItem: item });
  }

  handleTextFilterChange = (event) => {
    this.setState({ textFilter: event.target.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }, this.debouncedFetchItems)
  }

  handleDealsUpdated = () => {
    if (this.props.handleUpdatedDeals) this.props.handleUpdatedDeals()
  }

  showGroupAction = (action) => {
    switch (action) {
      case 'mark_attendee_confirmed':
        this.setState({ showGroupActionModal: true, groupAction: action, groupActionTitle: 'Seminar Confirm Attendees', groupActionText: "This will mark these registrations as 'Confirmed Attendee'" })
        break
      case 'mark_attendee_not_confirmed':
        this.setState({ showGroupActionModal: true, groupAction: action, groupActionTitle: 'Seminar Cannot Confirm Attendees', groupActionText: "This will mark these registrations as 'Couldnt Confirm Attendee'" })
        break
      case 'mark_seminar_not_attended':
        this.setState({ showGroupActionModal: true, groupAction: action, groupActionTitle: 'Seminar Not Attended', groupActionText: "This will mark these registrations as 'Didnt Attend Seminar'" })
        break
      case 'mark_seminar_attended':
        this.setState({ showGroupActionModal: true, groupAction: action, groupActionTitle: 'Seminar Attended', groupActionText: "This will mark these registrations as 'Attended Seminar'" })
        break
      case 'mark_cancelled':
        this.setState({ showGroupActionModal: true, groupAction: action, groupActionTitle: 'Cancel Registration', groupActionText: "This will mark these registrations as 'Cancelled'" })
        break
      case 'dead_deals':
        this.setState({ showGroupActionModal: true, groupAction: action, groupActionTitle: 'Mark as Dead Deals', groupActionText: "This will mark these registrations as 'Dead Deal' - this will be the end for these deals" })
        break
      default:
        console.log(action)
    }
  }

  groupAction = () => {
    const params = {
      deal_ids: this.selectedItems().map((item) => item.id),
      mark_dead_deal_create_follow_up: this.state.markDeadDealCreateFollowUp,
      mark_dead_deal_priority: this.state.markDeadDealPriority,
      mark_dead_deal_reason: this.state.markDeadDealReason,
      mark_dead_deal_lead_type: this.state.markDeadDealLeadType
    }
    SeminarRegistrationsService.groupAction(this.state.groupAction, params)
      .then((response) => {
        this.setState({ showGroupActionModal: false }, this.debouncedFetchItems)
        this.handleDealsUpdated()
        Alert.success(`Updated - ${this.state.groupActionTitle}`)
      })
      .catch((response) => { Alert.error(`<h1>Error updating</h1><p>${response.data.message}</p>`, { html: true, timeout: 10000 }) })
  }

  createLMTasks = (task) => {
    const params = { task: task, deal_ids: this.selectedItems().map((item) => item.id) }
    SeminarRegistrationsService.createLMTasks(params)
      .then((response) => {
        this.setState({ showGroupActionLMTaskModal: false, modalLMTaskIndex: null, modalLMTaskItem: null });
        Alert.success(`Created tasks - ${task.description}`)
      })
      .catch((response) => { Alert.error(`<h1>Error updating</h1><p>${response.data.message}</p>`, { html: true, timeout: 10000 }) })
  }

  render() {
    const authStore = this.context

    const headers = [
      { label: 'ID', key: 'registration_number' },
      { label: 'First Name', key: 'first_name' },
      { label: 'Student First Name', key: 'student_first_name' },
      { label: 'Email', key: 'email' },
      { label: 'Mobile', key: 'mobile' },
    ];

    const { loadingInProgress } = this.state;
    const profile = authStore.profile

    return (
      <div>
        <div className='row'>
          <div className="col-sm-2">
            <div style={{ margin: '0 0 10px 0' }}>
              <input type="text" placeholder="Search" className='form-control input-sm' value={this.state.textFilter} onChange={this.handleTextFilterChange} />
            </div>
          </div>
          <div className="col-sm-5">
            {this.state.view === 'confirmation' && <Button bsStyle="info" style={{ marginRight: 6 }} bsSize="xsmall" disabled={!this.groupActionsEnabled()} onClick={() => this.showGroupAction('mark_attendee_confirmed')}>Confirm Attendance</Button>}
            {this.state.view === 'confirmation' && <Button bsStyle="info" style={{ marginRight: 6 }} bsSize="xsmall" disabled={!this.groupActionsEnabled()} onClick={() => this.showGroupAction('mark_attendee_not_confirmed')}>Cannot Confirm Attendance</Button>}
            {this.state.view === 'attendance' && <Button bsStyle="info" style={{ marginRight: 6 }} bsSize="xsmall" disabled={!this.groupActionsEnabled()} onClick={() => this.showGroupAction('mark_seminar_attended')}>Confirm Attended</Button>}
            {this.state.view === 'attendance' && <Button bsStyle="info" style={{ marginRight: 6 }} bsSize="xsmall" disabled={!this.groupActionsEnabled()} onClick={() => this.showGroupAction('mark_seminar_not_attended')}>Did Not Attend</Button>}
            <Button bsStyle="info" style={{ marginRight: 6 }} bsSize="xsmall" disabled={!this.groupActionsEnabled()} onClick={() => this.showGroupAction('mark_cancelled')}>Cancel Registration</Button>
            {authStore.anyRoles(['review_sales', 'qc']) && <Button bsStyle="info" style={{ marginRight: 6 }} bsSize="xsmall" disabled={!this.groupActionsEnabled()} onClick={() => this.showGroupAction('dead_deals')}>Deal Deals</Button>}
          </div>
          <div className="col-sm-5">
            <ButtonToolbar>
              <DropdownButton
                bsStyle='info'
                bsSize='xsmall'
                title='Email'
                key='1'
                id='dropdown-group-actions'
                disabled={!this.groupActionsEnabled()}
              >
                {this.state.emailGroupMessages && this.state.emailGroupMessages.map((item, index) =>
                  <MenuItem key={index} eventKey={index} id={item.id} onClick={() => this.showMessageModal('email', index, item)}>{item.description}</MenuItem>
                )}
              </DropdownButton>
              <DropdownButton
                bsStyle='info'
                bsSize='xsmall'
                title='SMS'
                key='2'
                id='dropdown-group-actions'
                disabled={!this.groupActionsEnabled()}
              >
                {this.state.smsGroupMessages && this.state.smsGroupMessages.map((item, index) =>
                  <MenuItem key={index} eventKey={index} id={item.template_text} onClick={() => this.showMessageModal('sms', index, item)}>{item.description}</MenuItem>
                )}
              </DropdownButton>
              <DropdownButton
                bsStyle='info'
                bsSize='xsmall'
                title='LeadMachine Tasks'
                key='3'
                id='dropdown-group-actions'
                disabled={!this.groupActionsEnabled()}
              >

                {this.leadMachineGroupTasks().map((item, index) =>
                  <MenuItem key={index} eventKey={index} id={item.template_text} onClick={() => this.showLMTaskModal(index, item)}>{item.description}</MenuItem>
                )}
              </DropdownButton>
            </ButtonToolbar>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
          <LoadingIndicator loadingInProgress={loadingInProgress}>
              {!this.state.items || this.state.items.length === 0
                ? <h5>No matching registrations</h5>
                : <RegistrationsTable
                  seminar={this.props.seminar}
                  items={this.state.items}
                  itemSelectStateChanged={this.itemSelectStateChanged}
                  itemSelectAllChanged={this.itemSelectAllChanged}
                  view={this.state.view}
                  handleDealsUpdated={this.handleDealsUpdated}
                />}
            </LoadingIndicator>
          </div>
        </div>


        {this.state.items && this.state.items.length > 0 && <div style={{ marginTop: '30px' }}>
          <CSVWrapper data={this.state.items} headers={headers} asyncOnClick={false}>Download page as CSV</CSVWrapper>
        </div>}

        <Modal show={this.state.showMessageModal} onHide={this.closeMessageModal}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalMessageType} : {this.state.showMessageModal && this.state.modalMessageItem.description}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.sendingMessage
              ? <p>Sending message</p>
              : <div>
                <p>
                  This will send a message to {this.selectedItems().length} deals
            </p>

                <div className='form-group'>
                  <label>Send To</label>
                  <select className="form-control input-sm" value={this.state.modalMessageAudience} onChange={(e) => this.setState({ modalMessageAudience: e.target.value })}>
                    <option value='primary'>Primary Contact</option>
                    <option value='all'>All Contacts</option>
                    <option value='parents'>All Parent Contacts</option>
                    <option value='students'>All Student Contacts</option>
                  </select>
                </div>


                {this.state.modalMessageType === 'email' && <p>Sending a test will send an email to {profile.email}</p>}
                {this.state.modalMessageType === 'sms' && (profile.phone ? <p> Sending a test will send an SMS to {profile.phone} </p> : <p>You have no phone number setup to send a test to</p>)}
              </div>}
          </Modal.Body>
          <Modal.Footer>
            {!this.state.sendingMessage && <div>
              <Button onClick={this.closeMessageModal} bsSize='small'>Close</Button>
              <Button bsStyle='default' bsSize='small' onClick={() => this.sendMessage(true)}>Send test to yourself</Button>
              <Button bsStyle='primary' bsSize='small' onClick={() => this.sendMessage(false)}>Send to {this.selectedItems().length} deals</Button>
            </div>}
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showGroupActionLMTaskModal} onHide={() => this.setState({ showGroupActionLMTaskModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Create LM Tasks</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to create this LeadMachine task for the {this.selectedItems().length} registrations selected</p>
            <h4>{this.state.modalLMTaskItem && this.state.modalLMTaskItem.description}</h4>
            <p>{this.state.modalLMTaskItem && this.state.modalLMTaskItem['_comment']}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.setState({ showGroupActionLMTaskModal: false })} bsSize='small'>Woah, cancel this</Button>
            <Button bsStyle='info' bsSize='small' onClick={() => this.createLMTasks(this.state.modalLMTaskItem)}>I'm sure, go ahead and create tasks</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showGroupActionModal} onHide={() => this.setState({ showGroupActionModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.groupActionTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{this.selectedItems().length} registrations selected</p>
            <p>{this.state.groupActionText}</p>
            {this.state.groupAction === 'dead_deals' && <div>

              <div className="form-group">
                <label>Reason for Marking Dead</label>
                <select className="form-control" defaultValue={this.state.markDeadDealReason} onChange={(e) => { this.setState({ markDeadDealReason: e.target.value }) }} >
                  <option value='did_not_attend_seminar'>Did Not Attend Seminar</option>
                  <option value='couldnt_afford'>Couldn’t afford it</option>
                  <option value='student_not_interested'>Student not interested</option>
                  <option value='parent_not_interested'>Parent not interested</option>
                  <option value='wanted_tutor'>Wanted a tutor instead</option>
                  <option value='no_presentation'>No presentation given</option>
                  <option value='couldnt_verify'>Couldn't Verify Sale</option>
                  <option value='other'>Other</option>
                </select>
              </div>



              <h4>What to do next?</h4>
              <Checkbox checked={this.state.markDeadDealCreateFollowUp} onChange={() => { this.setState({ markDeadDealCreateFollowUp: !this.state.markDeadDealCreateFollowUp }) }}>
                Create Follow Ups for all these registrations?
              </Checkbox>
              {!this.state.markDeadDealCreateFollowUp && <p>These Deals will be marked as Dead, no Follow Ups will be created</p>}

              {this.state.markDeadDealCreateFollowUp && <div><p>These Deals will be marked as Dead Deals. A new Follow Up will be created for each Deal</p>

                <div className="form-group">
                  <label>Lead Type</label>
                  <select className="form-control" defaultValue={this.state.markDeadDealLeadType} onChange={(e) => { this.setState({ markDeadDealLeadType: e.target.value }) }} >
                    <option value='could_not_present_tcs'>Couldn’t present TCS</option>
                    <option value='could_not_confirm_tcs'>Couldn’t confirm TCS</option>
                    <option value='seminar_attended_did_not_book'>Seminar attended, did not book TCS</option>
                    <option value='seminar_register_did_not_attend'>Booked Seminar, did not attend</option>
                    <option value='other'>Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Follow Up Priority</label>
                  <select className="form-control" defaultValue={this.state.markDeadDealPriority} onChange={(e) => { this.setState({ markDeadDealPriority: e.target.value }) }} >
                    <option value='1'>Urgent</option>
                    <option value='2'>High Priority</option>
                    <option value='3'>Normal</option>
                    <option value='4'>Low Priority</option>
                    <option value='5'>Unimportant</option>
                  </select>import LoadingIndicator from '../Components/LoadingIndicator/LoadingIndicator';

                </div>
              </div>
              }

            </div>}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.setState({ showGroupActionModal: false })} bsSize='small'>Woah, cancel this</Button>
            <Button bsStyle='info' bsSize='small' onClick={() => this.groupAction()}>I'm sure, go ahead and change these registrations</Button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}
export default RegistrationsListView